import React from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import { Actions as PAYMENTACTIONS } from "../../../store/actions/paymentActions";
import { DocumentArrowDownIcon } from "@/icons/outline";
import { useMemo } from "react";

const CreditRow = ({
	credit,
	companyName,
	downloadInvoice,
	invoiceNo,
	creditId,
	hasPendingBills,
	selectCredit,
	isAdmin,
}) => {
	const details = useMemo(() => {
		const description = [];
		if (credit?.description) description.push(credit?.description);
		if (credit?.details) description.push(credit?.details);
		if (credit?.type === "Credit" && !description?.length) description.push("Credit Purchase");

		return description.join(" - ");
	}, [JSON.stringify(credit), companyName]);

	return (
		<tr>
			<td>
				{isAdmin && hasPendingBills && credit.billingStatus == "Pending" && (
					<label
						className="css-input switch switch-sm switch-success"
						style={{ margin: 0 }}
					>
						<input
							id="form-control form-input"
							name="select"
							className="checkbox-toggle"
							checked={credit.selected}
							onClick={() => selectCredit(credit.id)}
							type="checkbox"
							autoComplete="off"
						/>
						<span />
					</label>
				)}
			</td>
			<td>{format(new Date(credit?.date), "do MMM yyyy HH:mm")}</td>
			<td className={credit.type == "Debit" ? `text-danger` : `text-success`}>
				{credit.type == "Debit" ? `-` : `+`} {credit.credits}
			</td>
			<td>{credit?.balance}</td>
			<td>
				{details}
				<DownloadInvoice
					invoiceNo={invoiceNo}
					creditId={creditId}
					downloadInvoice={downloadInvoice}
				/>
			</td>
		</tr>
	);
};

function DownloadInvoice({ invoiceNo, creditId, downloadInvoice }) {
	if (!invoiceNo) return null;
	return (
		<>
			<span
				className="btn btn-default btn-xs"
				onClick={() => downloadInvoice(creditId)}
			>
				<DocumentArrowDownIcon
					className="h-5 w-5"
					style={{ verticalAlign: "middle" }}
				/>
			</span>
			{` - ${invoiceNo} `}
		</>
	);
}

const mapStateToProps = (state, ownProps) => {
	const credit = ownProps?.credit;
	const organisation = state?.organisations?.find((o) => o.id == credit?.company);

	return {
		companyName: organisation?.name,
		isAdmin: state?.my?.profile?.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({
	downloadInvoice: (creditId) => dispatch(PAYMENTACTIONS.downloadInvoice(creditId)),
	selectCredit: (creditId) => dispatch(PAYMENTACTIONS.selectCredit(creditId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditRow);
